import { useState } from 'react';
import { useLocation } from 'react-router';

import { useFetch, useListFetch, useRequest } from '../../hooks';
import { getAllContacts, getMessages, sendChatToServer } from '../../api';
import type { ContactItem } from '../../api';
import type { MessageItem, GetMessagesFilter } from '../../api';

export const useMessages = () => {
  const [chat, setChat] = useState('');

  const { data: contacts = [], intializing } = useFetch<ContactItem[]>(
    getAllContacts,
    [],
    {
      onSuccess: contacts => {
        if (result.filters?.contactId) return;

        result.setFilters({ ...result.filters, contactId: contacts[0]?.id });
      },
    }
  );

  const contactId = new URLSearchParams(useLocation().search).get('contactId');
  const result = useListFetch<MessageItem, GetMessagesFilter>(
    async params => {
      if (intializing) return { content: [] };

      const result = await getMessages(params.filters);

      return { content: result };
    },
    {
      deps: [intializing, contacts],
      withQueryParams: true,
      initialFilters: contactId ? { contactId } : {},
    }
  );

  const selectedContact = contacts?.find(
    c => c.id === result.filters?.contactId
  );
  const [sendChat, sending] = useRequest(
    async () => {
      if (!selectedContact || !chat.length) return;

      return sendChatToServer(selectedContact?.id!, chat);
    },
    {
      deps: [chat, selectedContact],
      onSuccess: () => {
        setChat('');
        result.refresh();
      },
    }
  );

  return {
    ...result,
    contacts: contacts || [],
    sending,
    selectedContact,
    chat,
    setChat,
    sendChat,
  };
};

export type Item = MessageItem;
